import { render, staticRenderFns } from "./IconGenuineMedications.vue?vue&type=template&id=43e55116&"
import script from "./IconGenuineMedications.vue?vue&type=script&lang=js&"
export * from "./IconGenuineMedications.vue?vue&type=script&lang=js&"
import style0 from "./IconGenuineMedications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports